<script>
    import Slider from './program_slider.svelte';
    import {
        foundersSlides,
        executivesSlides,
        investorsSlides,
        governmentSlides,
    } from './slider_data.js';
    let current = 'Founders';
    let currentMobile = 1;
    let selector;
    $: console.log(currentMobile);
</script>

<div class="desktop">
    <div class="program-section-class">
        <div class="container-fluid ">
            <div>
                <div class="row">
                    <div class="col-md-12 col-xl-12 p-0">
                        <div class="heading">
                            <h3 id="programs">Our Programs</h3>
                        </div>
                        <div class="program_menu">
                            <ul
                                class="d-flex justify-content-around list-unstyled"
                            >
                                <div class="ani" bind:this={selector} />
                                <li
                                    class={current === 'Founders' ? 'selected' : ''}
                                    on:click={() => {
                                        selector.style.marginLeft = '-56.9vw';
                                        selector.style.transitionDuration =
                                            '0.5s';
                                        selector.style.color = 'white';
                                        current = 'Founders';
                                        selector.style.width = '12.5vw';
                                        selector.style.fontSize = '1.323vw';
                                    }}
                                >
                                    <h5>Founders</h5>
                                </li>
                                <li
                                    class={current === 'Executives' ? 'selected' : ''}
                                    on:click={() => {
                                        selector.style.marginLeft = '-19.6vw';
                                        selector.style.transitionDuration =
                                            '0.5s';
                                        selector.style.color = 'white';
                                        current = 'Executives';
                                        selector.style.width = '12.5vw';
                                    }}
                                >
                                    <h5>Executives</h5>
                                </li>
                                <li
                                    class={current === 'Investors' ? 'selected' : ''}
                                    on:click={() => {
                                        selector.style.marginLeft = '17.5vw';
                                        selector.style.transitionDuration =
                                            '0.5s';
                                        selector.style.color = 'white';
                                        current = 'Investors';
                                        selector.style.width = '12.5vw';
                                    }}
                                >
                                    <h5>Investors</h5>
                                </li>
                                <li
                                    class={current === 'Government' ? 'selected' : ''}
                                    on:click={() => {
                                        selector.style.marginLeft = '55.5vw';
                                        selector.style.transitionDuration =
                                            '0.5s';
                                        selector.style.color = 'white';
                                        current = 'Government';
                                        selector.style.width = '13.5vw';
                                    }}
                                >
                                    <h5>Government</h5>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            {#if current === 'Founders'}
                <Slider slides={foundersSlides} />
            {:else if current === 'Executives'}
                <Slider slides={executivesSlides} />
            {:else if current === 'Investors'}
                <Slider slides={investorsSlides} />
            {:else}
                <Slider slides={governmentSlides} />
            {/if}
        </div>
    </div>
</div>

<!---Mobile-->
<div class="mobile">
    <div
        class="mobile-wrapper"
        style="
    position: relative;"
    >
        <div id="programs_mob">
            <h1
                style="font-weight: 700;font-size: 5.607vw;line-height: 29px;color: #035BA0;text-align: center;margin:8vw 0vw;"
            >
                Our Programs
            </h1>
            <div class="mobile_menu_btns">
                <div
                    class="menu_btns"
                    on:click={() => {
                        currentMobile = 1;
                    }}
                >
                    <h3 class={currentMobile === 1 ? 'selected-mobile' : ''}>
                        Founders
                    </h3>
                </div>
                <div
                    class="menu_btns"
                    on:click={() => {
                        currentMobile = 2;
                    }}
                >
                    <h3 class={currentMobile === 2 ? 'selected-mobile' : ''}>
                        Executives
                    </h3>
                </div>
                <div
                    class="menu_btns"
                    on:click={() => {
                        currentMobile = 3;
                    }}
                >
                    <h3 class={currentMobile === 3 ? 'selected-mobile' : ''}>
                        Investors
                    </h3>
                </div>
                <div
                    class="menu_btns"
                    on:click={() => {
                        currentMobile = 4;
                    }}
                >
                    <h3 class={currentMobile === 4 ? 'selected-mobile' : ''}>
                        Government
                    </h3>
                </div>
            </div>
        </div>

        <div>
            {#if currentMobile === 1}
                <Slider slides={foundersSlides} />
            {:else if currentMobile === 2}
                <Slider slides={executivesSlides} />
            {:else if currentMobile === 3}
                <Slider slides={investorsSlides} />
            {:else if currentMobile === 4}
                <Slider slides={governmentSlides} />
            {/if}
        </div>
        <div class="controls">
            {#if currentMobile === 1}
                <button
                    class="button2"
                    style="margin-left:89.215vw;"
                    on:click={() => {
                        currentMobile++;
                    }}
                >
                    <img
                        src="images/fundamental_programs/next_button.svg"
                        alt=""
                        width="100%"
                        style="width:6.893vw"
                    />
                </button>
            {:else if currentMobile === 2 || currentMobile === 3}
                <button
                    class="button2"
                    style="margin-left:89.215vw;"
                    on:click={() => {
                        currentMobile++;
                    }}
                >
                    <img
                        src="images/fundamental_programs/next_button.svg"
                        alt=""
                        width="100%"
                        style="width:6.893vw"
                    /></button
                >

                <button
                    class="button1"
                    style="margin-left:4.498vw;"
                    on:click={() => {
                        currentMobile--;
                    }}
                >
                    <img
                        src="images/fundamental_programs/next_button.svg"
                        alt=""
                        width="100%"
                        style="    transform: rotate(180deg);
                        width: 6.893vw;
                        margin-top: -14.4vw;"
                    />
                </button>
            {:else if currentMobile === 4}
                <button
                    class="button1"
                    style="margin-left:4.498vw;"
                    on:click={() => {
                        currentMobile--;
                    }}
                >
                    <img
                        src="images/fundamental_programs/next_button.svg"
                        alt=""
                        width="100%"
                        style="transform: rotate(180deg);
                width:6.893vw"
                    />
                </button>
            {/if}
        </div>
    </div>
</div>

<style>
    .program-section-class {
        height: 66vw;
    }
    h5 {
        display: block;
    }
    .selected {
        transform: scale(1.2);
        color: white;
        transition-delay: 0.3s;
        transition-duration: 0s;
    }
    .d-flex {
        background-color: #e2f2ff;
        color: #00204b;
        width: 100%;
        padding-left: 12vw;
        padding-right: 12vw;
    }
    .heading {
        text-align: center;
        color: #00204b;
        margin: 5vw 0;
    }
    .heading h3 {
        font-size: 3.968vw;
        font-weight: 600;
    }
    .program_menu ul li {
        cursor: pointer;
        padding: 1vw 3vw;
    }
    .program_menu ul li h5 {
        font-size: 1.058vw !important;
        font-weight: 600;
        margin-bottom: 0;
    }
    ul li::marker {
        color: #7cc1ff;
    }
    .ani {
        position: absolute;
        width: 12.5vw;
        margin-left: -56.9vw;
        margin-top: -0.9vw;
        height: 5vw;
        background-color: #035ba0;
        box-shadow: 0px 4px 4px 0px #00000040;
        border-radius: 0.5vw;
    }
    .button1 {
        border: none;
        background: none;
    }
    .button2 {
        border: none;
        background: none;
    }
    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .mobile {
            display: block;
            margin-bottom: 185vw;
            margin-top: -20vw;
        }
    }
    .mobile_menu_btns {
        display: flex;
        flex-wrap: wrap;
        gap: 4vw;
        justify-content: center;
    }
    .controls {
        position: absolute;
        top: 197vw;
    }
    .mobile_menu_btns .menu_btns {
        width: 32.477vw;
        height: 9.579vw;
        background: #eff5ff;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        border-radius: 2.336vw;
    }
    .mobile_menu_btns .menu_btns h3 {
        font-weight: 400;
        font-size: 2.804vw;
        line-height: 3.505vw;
        padding-top: 3vw;
        color: #00204b;
        text-align: center;
    }
    .selected-mobile {
        background-color: #035ba0 !important;
        transition-duration: 0.2s;
        height: 100%;
        width: 100%;
        font-size: 3.2vw !important;
        padding-top: 3vw;
        font-weight: 900 !important;
        color: white !important;
    }
</style>
